export const HOTEL_SEARCH_NEW_FILTER_OPTIONS = new Set(['homes_villas'])
